import {Box, Skeleton} from "@mui/material";

export default function PageSkeleton() {
    return (
        <Box>
            <Box sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '1rem',
                paddingBottom: '1rem',
                borderBottom: '1px solid',
                borderColor: 'divider',
            }}>
                <Skeleton variant="text" width={220} height={40}/>
                <Skeleton variant="rounded" width={140} height={40}/>
            </Box>
            <Skeleton variant="rounded" height={64} sx={{mb: 2, borderRadius: '16px'}}/>
            <Skeleton variant="rounded" height={220} sx={{mb: 2, borderRadius: '16px'}}/>
            <Skeleton variant="rounded" height={160} sx={{borderRadius: '16px'}}/>
        </Box>
    );
}
